import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { authSlice } from './authSlice';
import { packingReducer } from './packing';
var store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        packing: packingReducer
    },
    middleware: getDefaultMiddleware({
        serializableCheck: false
    })
});
export default store;
